import type {
  DashboardRateInput,
  ExtranetIncidentsListInput,
  ExtranetInvoicesListInput,
  ExtranetRidesListInput,
  InvitationsListInput,
  MembersListInput,
  VolumeIncidentsInterval,
} from '../../types/extranet-api.types';

/**
 * Toutes les clés de session sont préfixées `extranet` : `clearExtranetCache`
 * (lib/session.ts) les purge à la déconnexion. Les clés publiques (acceptation
 * d'invitation) sont préfixées `extranet-public` pour y échapper.
 */
export const extranetQueryKeys = {
  account: {
    me: () => ['extranet', 'account', 'me'] as const,
  },
  dashboard: {
    root: () => ['extranet', 'dashboard'] as const,
    rate: (metric: string, input: DashboardRateInput) => ['extranet', 'dashboard', 'rate', metric, input] as const,
    incidentCategoryBuckets: (input: DashboardRateInput) =>
      ['extranet', 'dashboard', 'incident-category-buckets', input] as const,
    incidentTimeSeries: (input: DashboardRateInput & { interval?: VolumeIncidentsInterval }) =>
      ['extranet', 'dashboard', 'incident-timeseries', input] as const,
    notes: (input: DashboardRateInput) => ['extranet', 'dashboard', 'dashboard-notes', input] as const,
  },
  rides: {
    root: () => ['extranet', 'rides'] as const,
    list: (input: ExtranetRidesListInput) => ['extranet', 'rides', 'list', input] as const,
    autocomplete: (search: string, limit: number) => ['extranet', 'rides', 'autocomplete', search, limit] as const,
  },
  incidents: {
    root: () => ['extranet', 'incidents'] as const,
    list: (input: ExtranetIncidentsListInput) => ['extranet', 'incidents', 'list', input] as const,
  },
  performance: {},
  invoices: {
    root: () => ['extranet', 'invoices'] as const,
    list: (input: ExtranetInvoicesListInput) => ['extranet', 'invoices', 'list', input] as const,
  },
  members: {
    root: () => ['extranet', 'members'] as const,
    list: (input: MembersListInput) => ['extranet', 'members', 'list', input] as const,
  },
  invitations: {
    root: () => ['extranet', 'invitations'] as const,
    list: (input: InvitationsListInput) => ['extranet', 'invitations', 'list', input] as const,
  },
  publicInvitation: {
    preview: (token: string, accountKey: string) => ['extranet-public', 'invitation', token, accountKey] as const,
  },
};
